import {useEffect, useState, useCallback} from 'react';

import GooglePayWorldpayHandler from 'coreClasses/googlepay/GooglePayWorldpayHandler';
import {loadScript} from 'coreUtils/utils';
import {useRequestClass} from 'coreHooks';

import {useGeneralProvider} from 'brand/app/components/_app-config/GeneralProvider';

let initializationPromise;
let globalGooglePayHandler;

/**
 * useGooglePayWorldpay custom hook.
 * @param {boolean} [isActive=false] - indicate whatever this hook is active
 * @param {Object} config - ApplePay configuration
 */
const useGooglePayWorldpay = (isActive, config) => {
	const {managerRepository} = useGeneralProvider();
	const [loaded, setLoaded] = useState(!!globalGooglePayHandler);
	const [loading, setLoading] = useState(!!initializationPromise);
	const {isProduction} = useRequestClass();

	useEffect(() => {
		if (
			isActive &&
			!globalGooglePayHandler &&
			!initializationPromise
		) {
			setLoading(true);

			initializationPromise = new Promise<void>((resolve) => {
				loadScript(
					'https://pay.google.com/gp/p/js/pay.js',
					'googlepay'
				).then(() => {
					globalGooglePayHandler = new GooglePayWorldpayHandler(
						managerRepository,
						config,
						!isProduction
					);
					globalGooglePayHandler.onGooglePayLoaded().then((isReady) => {
						setLoaded(isReady);
						setLoading(!isReady);
						resolve();
						initializationPromise = null;
					});
				}).catch(() => {
					setLoading(false);
				});
			});
		} else if (initializationPromise) {
			initializationPromise.then(() => {
				setLoaded(true);
				setLoading(false);
			});
		}
	}, [isActive]);

	const handlePayment = useCallback((productId, handleClickCallback = null, basketId) => {
		globalGooglePayHandler.handlePayment(productId, handleClickCallback, basketId);
	}, []);

	const getButton = useCallback((onClick, googlePayButtonStylesConfig) => {
		return globalGooglePayHandler.getButton(onClick, googlePayButtonStylesConfig);
	}, []);

	return {
		loaded,
		loading,
		handle: handlePayment,
		getButton: getButton
	};
};

export default useGooglePayWorldpay;
